import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    title: 'RosterRise | Youth Football Team Operations',
    loadComponent: () => import('./pages/home/home.page').then(c => c.HomePage),
  },
  {
    path: 'features',
    title: 'Features | RosterRise',
    loadComponent: () =>
      import('./pages/features/features.page').then(c => c.FeaturesPage),
  },
  {
    path: 'pricing',
    title: 'Pricing | RosterRise',
    loadComponent: () =>
      import('./pages/pricing/pricing.page').then(c => c.PricingPage),
  },
  {
    path: 'contact',
    title: 'Contact | RosterRise',
    loadComponent: () =>
      import('./pages/contact/contact.page').then(c => c.ContactPage),
  },
  {
    path: 'sales',
    title: 'Sales | RosterRise',
    loadComponent: () =>
      import('./pages/sales/sales.page').then(c => c.SalesPage),
  },
  {
    path: 'demo',
    title: 'Product Walkthrough | RosterRise',
    loadComponent: () => import('./pages/demo/demo.page').then(c => c.DemoPage),
  },
  {
    path: 'help',
    title: 'Help Center | RosterRise',
    loadComponent: () => import('./pages/help/help.page').then(c => c.HelpPage),
  },
  {
    path: 'privacy-policy',
    title: 'Privacy Policy | RosterRise',
    loadComponent: () =>
      import('./pages/legal/privacy-policy/privacy-policy.page').then(
        c => c.PrivacyPolicyPage
      ),
  },
  {
    path: 'terms-of-service',
    title: 'Terms of Service | RosterRise',
    loadComponent: () =>
      import('./pages/legal/terms-of-service/terms-of-service.page').then(
        c => c.TermsOfServicePage
      ),
  },
  {
    path: 'cookie-policy',
    title: 'Cookie Notice | RosterRise',
    loadComponent: () =>
      import('./pages/legal/cookie-policy/cookie-policy.page').then(
        c => c.CookiePolicyPage
      ),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
